import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';

const divisionsData = {
  'coffee-export': {
    title: 'Coffee Export',
    description: 'We export high-quality Ethiopian coffee to the world.',
    image: '/images/coffee.jpg',
  },
  'oilseeds-export': {
    title: 'Oilseeds Export',
    description: 'Premium oilseeds sourced directly from Ethiopian farmers.',
    image: '/images/oilseeds.jpg',
  },
  'pulses-export': {
    title: 'Pulses Export',
    description: 'Providing nutritious pulses with superior quality.',
    image: '/images/pulses.jpg',
  },
};

export default function DivisionPage() {
  const { divisionName } = useParams();
  const [division, setDivision] = useState(null);

  useEffect(() => {
    // Update content when the URL changes
    setDivision(divisionsData[divisionName] || null);
  }, [divisionName]);

  if (!division) {
    return <h1 className="text-center text-red-500">Division Not Found</h1>;
  }

  return (
    <div className="p-10">
      <img src={division.image} alt={division.title} className="w-full h-80 object-cover rounded-md" />
      <h1 className="text-3xl font-bold mt-6">{division.title}</h1>
      <p className="mt-4 text-lg">{division.description}</p>
    </div>
  );
}


